import React from 'react';
import { string, arrayOf, bool, func, number } from 'prop-types';
import { FormattedMessage, injectIntl, intlShape } from '../../util/reactIntl';
import dropWhile from 'lodash/dropWhile';
import classNames from 'classnames';
import { Avatar, InlineTextButton, ReviewRating, UserDisplayName } from '../../components';
import { formatDate } from '../../util/dates';
import { ensureTransaction, ensureUser, ensureListing } from '../../util/data';
import {
  TRANSITION_ENQUIRE,
  TRANSITION_REQUEST_AFTER_ENQUIRY,
  TRANSITION_REQUEST,
  TRANSITION_SEND_OFFER,
  TRANSITION_SEND_CALENDAR_LINK,
  TRANSITION_APPROVE_OFFER,
  TRANSITION_CANCELL_OFFER_BY_CUSTOMER,
  TRANSITION_CANCELL_OFFER_BY_PROVIDER,
  TRANSITION_SEND_COUNTEROFFER_BY_CUSTOMER,
  TRANSITION_SEND_COUNTEROFFER_BY_PROVIDER,
  TRANSITION_APPROVE_COUNTEROFFER,
  TRANSITION_UPLOAD_DOCUMENTS,
  TRANSITION_UPLOAD_SIGNED_DOCUMENTS,
  TRANSITION_REQUEST_OFFER_COMPLETE,
  TRANSITION_DECLINE_OFFER_COMPLETE,
  TRANSITION_ACCEPT_OFFER_COMPLETE,

  TRANSITION_OPERATOR_CANCEL_ENQUIRY,
  TRANSITION_OPERATOR_CANCEL_REQUESTED,
  TRANSITION_OPERATOR_CANCEL_COUNTEROFFER_RECEIVED,
  TRANSITION_OPERATOR_CANCEL_OFFER_RECEIVED,

  txIsDelivered,
  txRoleIsProvider,
  txRoleIsCustomer,
  getUserTxRole,
  isRelevantPastTransition,
} from '../../util/transaction';
import { propTypes } from '../../util/types';
import * as log from '../../util/log';
import css from './ActivityFeed.module.css';
import { types as sdkTypes } from '../../util/sdkLoader';
import InsertDriveFileIcon from '@material-ui/icons/InsertDriveFile';
import { handleDownloadFile } from './utils';

const Message = props => {
  const { message, intl } = props;
  const todayString = intl.formatMessage({ id: 'ActivityFeed.today' });

  if (message.attributes.content.includes('azure510-') > 0) {
    const stripedName =
      message.attributes.content.split('-') && message.attributes.content.split('-')[2];

    const hrefIndex = message.attributes.content.indexOf("href")
    const shortenedFileName = message.attributes.content.slice(9, hrefIndex)
    const fileUrl = message.attributes.content.slice(hrefIndex + 4)

    return (
      // <div className={css.ownMessageAzure} onClick={() => handleDownloadFile(message)}>
      <div className={css.otherMessageAzure}>
        <Avatar className={css.avatar} user={message.sender} />
        <div>
          <a className={css.messageContent} href={fileUrl} download target="_blank">
            <InsertDriveFileIcon className={css.fileIcon} fontSize="large" />
            <span>{shortenedFileName}</span>
          </a>
          <p className={css.ownMessageDate}>
            {formatDate(intl, todayString, message.attributes.createdAt)}
          </p>
        </div>
      </div>
    );
  } else {
    return (
      <div className={css.message}>
        <Avatar className={css.avatar} user={message.sender} />
        <div>
          <p className={css.messageContent}>{message.attributes.content}</p>
          <p className={css.messageDate}>
            {formatDate(intl, todayString, message.attributes.createdAt)}
          </p>
        </div>
      </div>
    );
  }
};

Message.propTypes = {
  message: propTypes.message.isRequired,
  intl: intlShape.isRequired,
};

const OwnMessage = props => {
  const { message, intl } = props;
  const todayString = intl.formatMessage({ id: 'ActivityFeed.today' });

  if (message.attributes.content.includes('azure510-') > 0) {
    // const stripedName =
    //   message.attributes.content.split('-') && message.attributes.content.split('-')[2];
    // const shortenedFileName = stripedName;
    const hrefIndex = message.attributes.content.indexOf("href")
    const shortenedFileName = message.attributes.content.slice(9, hrefIndex)
    const fileUrl = message.attributes.content.slice(hrefIndex + 4)
    return (
      // <div className={css.ownMessageAzure} onClick={() => handleDownloadFile(message)}>
      <div className={css.ownMessageAzure}>
        <div>
          <a className={css.ownMessageContent} href={fileUrl} download target="_blank">
            <InsertDriveFileIcon className={css.fileIcon} fontSize="large" />
            <span>{shortenedFileName}</span>
          </a>
          <p className={css.ownMessageDate}>
            {formatDate(intl, todayString, message.attributes.createdAt)}
          </p>
        </div>
      </div>
    );
  } else {
    return (
      <div className={css.ownMessage}>
        <div className={css.ownMessageContentWrapper}>
          <p className={css.ownMessageContent}>{message.attributes.content}</p>
        </div>
        <p className={css.ownMessageDate}>
          {formatDate(intl, todayString, message.attributes.createdAt)}
        </p>
      </div>
    );
  }
};
OwnMessage.propTypes = {
  message: propTypes.message.isRequired,
  intl: intlShape.isRequired,
};

const Review = props => {
  const { content, rating } = props;
  return (
    <div>
      <p className={css.reviewContent}>{content}</p>
      {rating ? (
        <ReviewRating
          reviewStarClassName={css.reviewStar}
          className={css.reviewStars}
          rating={rating}
        />
      ) : null}
    </div>
  );
};

Review.propTypes = {
  content: string.isRequired,
  rating: number.isRequired,
};


const resolveTransitionMessage = (
  transaction,
  transition,
  listingTitle,
  ownRole,
  otherUsersName,
  intl,
  onOpenReviewModal,
  index
) => {
  const isOwnTransition = transition.by === ownRole;
  const currentTransition = transition.transition;
  const displayName = ownRole === "customer" ? listingTitle : otherUsersName;


  const desclineDescription = transaction?.attributes?.protectedData?.desclineDescription?.filter(item => item.key === index)?.[0];

  switch (currentTransition) {

    case TRANSITION_ENQUIRE:
      return isOwnTransition ? (
        <FormattedMessage id="ActivityFeed.ownTransitionContact" values={{ displayName: displayName }} />
      ) : (
        <FormattedMessage
          id="ActivityFeed.transitionContact"
          values={{ displayName }}
        />
      );

    case TRANSITION_REQUEST:
    case TRANSITION_REQUEST_AFTER_ENQUIRY:
      return isOwnTransition ? (
        <FormattedMessage id="ActivityFeed.ownTransitionRFQ" values={{ displayName: displayName }} />
      ) : (
        <FormattedMessage
          id="ActivityFeed.transitionRFQ"
          values={{
            displayName,
            sendAQuote: <b><FormattedMessage id="ActivityFeed.sendAQuote" /></b>
          }}
        />
      );
    case TRANSITION_SEND_CALENDAR_LINK:
      return isOwnTransition ? (
        <FormattedMessage id="ActivityFeed.ownTransitionSendCalendarLink" />
      ) : (
        <FormattedMessage id="ActivityFeed.transitionSendCalendarLink" values={{ displayName }} />
      );
    case TRANSITION_SEND_OFFER:
      return isOwnTransition ? (
        <FormattedMessage id="ActivityFeed.ownSentQuotation" values={{ displayName }} />
      ) : (
        <FormattedMessage
          id="ActivityFeed.sentQuotation"
          values={{
            quoteReceived: (
              <span className={css.blueText}>
                <FormattedMessage id="ActivityFeed.quoteReceived" />
              </span>
            )
          }}
        />
      );
    case TRANSITION_APPROVE_OFFER:
      return isOwnTransition ? (
        <FormattedMessage
          id="ActivityFeed.ownTransitionAccept"
          values={{
            displayName, acceptedOffer: (
              <span className={css.blueText}>
                <FormattedMessage id="ActivityFeed.youAcceptedOffer" />
              </span>
            )
          }}
        // values={{
        //   paymentLink: (
        //     <a className={css.blueTextLink}>
        //       <FormattedMessage id="ActivityFeed.paymentLink" />
        //     </a>
        //   )
        // }}
        />
      ) : (
        <span className={css.blueText}>
          <FormattedMessage
            id="ActivityFeed.transitionAccept"
            values={{
              customerAcceptedOffer: (
                <span className={css.blueText}>
                  <FormattedMessage id="ActivityFeed.customerAcceptedOffer" values={{ displayName }} />
                </span>
              ),
              workCompletedText: (
                <>
                  <br />
                  <span className={css.defaultText}>
                    <FormattedMessage id="ActivityFeed.workCompletedText" />
                  </span>
                </>
              )
            }}
          />
        </span>
      );
    case TRANSITION_CANCELL_OFFER_BY_CUSTOMER:
      return isOwnTransition ? (
        <span className={css.redText}>
          <FormattedMessage id="ActivityFeed.ownTransitionDeclineQuotation" values={{ displayName }} />
        </span>
      ) : (
        <span className={css.redText}>
          <FormattedMessage
            id="ActivityFeed.transitionDeclineQuotation"
            values={{ displayName }}
          />
        </span>
      );
    case TRANSITION_CANCELL_OFFER_BY_PROVIDER:
      return isOwnTransition ? (
        <span className={css.redText}>
          <FormattedMessage id="ActivityFeed.ownTransitionDeclineQuotationByProvider" values={{ displayName }} />
        </span>
      ) : (
        <span className={css.redText}>
          <FormattedMessage id="ActivityFeed.transitionDeclineQuotationByProvider" values={{ displayName }} />
        </span>
      );
    case TRANSITION_SEND_COUNTEROFFER_BY_CUSTOMER:
      return isOwnTransition ? (
        <FormattedMessage id="ActivityFeed.ownTransitionSendCounterOffer" values={{ displayName }} />
      ) : (
        <FormattedMessage id="ActivityFeed.transitionSendCounterOffer" />
      );
    case TRANSITION_SEND_COUNTEROFFER_BY_PROVIDER:
      return isOwnTransition ? (
        <FormattedMessage id="ActivityFeed.ownSentQuotation" values={{ displayName }} />
      ) : (
        <FormattedMessage
          id="ActivityFeed.sentQuotation"
          values={{
            quoteReceived: (
              <span className={css.blueText}>
                <FormattedMessage id="ActivityFeed.quoteReceived" />
              </span>
            )
          }}
        />
      );
    case TRANSITION_APPROVE_COUNTEROFFER:
      return isOwnTransition ? (
        <FormattedMessage id="ActivityFeed.ownTransitionApproveCounterOffer"
          values={{
            displayName,
            acceptedCounterOffer: (
              <span className={css.blueText}>
                <FormattedMessage id="ActivityFeed.youAcceptedCounterOffer" />
              </span>
            ),
            workCompletedText: (
              <>
                <br />
                <span className={css.defaultText}>
                  <FormattedMessage id="ActivityFeed.workCompletedText" />
                </span>
              </>
            )
          }}
        />
      ) : (
        <span className={css.blueText}>
          <FormattedMessage
            id="ActivityFeed.transitionApproveCounterOffer"
            values={{
              paymentLink: (
                <a className={css.blueTextLink}>
                  <FormattedMessage id="ActivityFeed.paymentLink" />
                </a>
              ),
              displayName
            }}
          />
        </span>
      );
    case TRANSITION_UPLOAD_DOCUMENTS:
      return isOwnTransition ? (
        <FormattedMessage id="ActivityFeed.ownTransitionUploadDocuments" />
      ) : (
        <FormattedMessage id="ActivityFeed.transitionUploadDocuments" values={{ displayName }} />
      );
    case TRANSITION_UPLOAD_SIGNED_DOCUMENTS:
      return isOwnTransition ? (
        <FormattedMessage id="ActivityFeed.ownTransitionUploadSignedDocuments" values={{ displayName }} />
      ) : (
        <FormattedMessage id="ActivityFeed.transitionUploadSignedDocuments" values={{ displayName }} />
      );
    case TRANSITION_REQUEST_OFFER_COMPLETE:
      return isOwnTransition ? (
        <FormattedMessage id="ActivityFeed.ownTransitionRequestOfferComplete" values={{ displayName }} />
      ) : (
        <FormattedMessage id="ActivityFeed.transitionRequestOfferComplete" values={{ displayName }} />
      );
    case TRANSITION_DECLINE_OFFER_COMPLETE:
      return isOwnTransition ? (
        <span className={css.redText}>
          <FormattedMessage
            id="ActivityFeed.ownTransitionDecline"
            values={{ desclineDescription: desclineDescription?.value || null }}
          />
        </span>
      ) : (
        <span className={css.redText}>
          <FormattedMessage id="ActivityFeed.transitionDecline"
            values={{ displayName, desclineDescription: desclineDescription?.value || null }}
          />
        </span>
      );
    case TRANSITION_ACCEPT_OFFER_COMPLETE:
      return isOwnTransition ? (
        <span className={css.blueText}>
          <FormattedMessage id="ActivityFeed.ownTransitionComplete" />
        </span>
      ) : (
        <span className={css.blueText}>
          <FormattedMessage id="ActivityFeed.transitionComplete" values={{ displayName }} />
        </span>
      );

    case TRANSITION_OPERATOR_CANCEL_ENQUIRY:
    case TRANSITION_OPERATOR_CANCEL_REQUESTED:
    case TRANSITION_OPERATOR_CANCEL_COUNTEROFFER_RECEIVED:
    case TRANSITION_OPERATOR_CANCEL_OFFER_RECEIVED:
      return <FormattedMessage id="ActivityFeed.ownTransitionComplete" />

    default:
      log.error(new Error('Unknown transaction transition type'), 'unknown-transition-type', {
        transitionType: currentTransition,
      });
      // return '';
      return <span>-------------------------</span>;
  }
};

const reviewByAuthorId = (transaction, userId) => {
  return transaction.reviews.filter(
    r => !r.attributes.deleted && r.author.id.uuid === userId.uuid
  )[0];
};

const Transition = props => {
  const { transition, transaction, currentUser, intl, onOpenReviewModal, index } = props;

  const currentTransaction = ensureTransaction(transaction);
  const customer = currentTransaction.customer;
  const provider = currentTransaction.provider;

  const deletedListing = intl.formatMessage({
    id: 'ActivityFeed.deletedListing',
  });
  // const listingTitle = currentTransaction.listing.attributes.deleted
  //   ? deletedListing
  //   : currentTransaction.listing.attributes.title;

  const listingTitle = currentTransaction.listing.attributes.deleted
    ? deletedListing
    : !!currentTransaction?.listing?.attributes?.publicData?.customDisplayName ?
      currentTransaction?.listing?.attributes?.publicData?.customDisplayName
      : currentTransaction.listing.attributes.title;

  const lastTransition = currentTransaction.attributes.lastTransition;

  const ownRole = getUserTxRole(currentUser.id, currentTransaction);

  const otherUsersName = txRoleIsProvider(ownRole) ? (
    <UserDisplayName user={customer} intl={intl} />
  ) : (
    <UserDisplayName user={provider} intl={intl} />
  );

  const transitionMessage = resolveTransitionMessage(
    transaction,
    transition,
    listingTitle,
    ownRole,
    otherUsersName,
    intl,
    onOpenReviewModal,
    index
  );

  const currentTransition = transition.transition;

  const deletedReviewContent = intl.formatMessage({ id: 'ActivityFeed.deletedReviewContent' });
  let reviewComponent = null;

  const todayString = intl.formatMessage({ id: 'ActivityFeed.today' });

  if (!transitionMessage) {
    return null
  }

  return (
    <div className={css.transition}>
      <div className={css.bullet}>
        <p className={css.transitionContent}>•</p>
      </div>
      <div>
        <p className={
          classNames(
            css.transitionContent,
            { [css.transitionContentBlue]: transition?.transition === 1 },
            { [css.transitionContentRed]: transition?.transition === 2 },
          )}>
          {transitionMessage}
        </p>
        <p className={css.transitionDate}>{formatDate(intl, todayString, transition.createdAt)}</p>
        {reviewComponent}
      </div>
    </div>
  );
};

Transition.propTypes = {
  transition: propTypes.transition.isRequired,
  transaction: propTypes.transaction.isRequired,
  currentUser: propTypes.currentUser.isRequired,
  intl: intlShape.isRequired,
  onOpenReviewModal: func.isRequired,
};

const EmptyTransition = () => {
  return (
    <div className={css.transition}>
      <div className={css.bullet}>
        <p className={css.transitionContent}>•</p>
      </div>
      <div>
        <p className={css.transitionContent} />
        <p className={css.transitionDate} />
      </div>
    </div>
  );
};

const isMessage = item => item && item.type === 'message';

// Compare function for sorting an array containing messages and transitions
const compareItems = (a, b) => {
  const itemDate = item => (isMessage(item) ? item.attributes.createdAt : item.createdAt);
  return itemDate(a) - itemDate(b);
};

const organizedItems = (messages, transitions, hideOldTransitions) => {
  const items = messages.concat(transitions).sort(compareItems);
  if (hideOldTransitions) {
    // Hide transitions that happened before the oldest message. Since
    // we have older items (messages) that we are not showing, seeing
    // old transitions would be confusing.
    return dropWhile(items, i => !isMessage(i));
  } else {
    return items;
  }
};

export const ActivityFeedComponent = props => {
  const {
    rootClassName,
    className,
    messages,
    transaction,
    currentUser,
    hasOlderMessages,
    onOpenReviewModal,
    onShowOlderMessages,
    fetchMessagesInProgress,
    intl,
  } = props;
  const classes = classNames(rootClassName || css.root, className);

  const currentTransaction = ensureTransaction(transaction);
  const transitions = currentTransaction.attributes.transitions
    ? currentTransaction.attributes.transitions
    : [];
  const currentCustomer = ensureUser(currentTransaction.customer);
  const currentProvider = ensureUser(currentTransaction.provider);
  const currentListing = ensureListing(currentTransaction.listing);

  const transitionsAvailable = !!(
    currentUser &&
    currentUser.id &&
    currentCustomer.id &&
    currentProvider.id &&
    currentListing.id
  );

  // combine messages and transaction transitions
  const items = organizedItems(messages, transitions, hasOlderMessages || fetchMessagesInProgress);

  const transitionComponent = (transition, index) => {
    if (transitionsAvailable) {
      return (
        <Transition
          transition={transition}
          transaction={transaction}
          currentUser={currentUser}
          intl={intl}
          onOpenReviewModal={onOpenReviewModal}
          index={index}
        />
      );
    } else {
      return <EmptyTransition />;
    }
  };

  const messageComponent = message => {
    const isOwnMessage =
      message.sender &&
      message.sender.id &&
      currentUser &&
      currentUser.id &&
      message.sender.id.uuid === currentUser.id.uuid;
    if (isOwnMessage) {
      return <OwnMessage message={message} intl={intl} />;
    }
    return <Message message={message} intl={intl} />;
  };

  const messageListItem = message => {
    return (
      <li id={`msg-${message.id.uuid}`} key={message.id.uuid} className={css.messageItem}>
        {messageComponent(message)}
      </li>
    );
  };

  const transitionListItem = (transition, i) => {
    if (isRelevantPastTransition(transition.transition)) {
      return (
        <li key={transition.transition + i} className={css.transitionItem}>
          {transitionComponent(transition, i)}
        </li>
      );
    } else {
      return null;
    }
  };

  return (
    <ul className={classes}>
      {hasOlderMessages ? (
        <li className={css.showOlderWrapper} key="show-older-messages">
          <InlineTextButton className={css.showOlderButton} onClick={onShowOlderMessages}>
            <FormattedMessage id="ActivityFeed.showOlderMessages" />
          </InlineTextButton>
        </li>
      ) : null}
      {items.map((item, i) => {
        if (isMessage(item)) {
          return messageListItem(item);
        } else {
          return transitionListItem(item, i);
        }
      })}
    </ul>
  );
};

ActivityFeedComponent.defaultProps = {
  rootClassName: null,
  className: null,
};

ActivityFeedComponent.propTypes = {
  rootClassName: string,
  className: string,

  currentUser: propTypes.currentUser,
  transaction: propTypes.transaction,
  messages: arrayOf(propTypes.message),
  hasOlderMessages: bool.isRequired,
  onOpenReviewModal: func.isRequired,
  onShowOlderMessages: func.isRequired,
  fetchMessagesInProgress: bool.isRequired,

  // from injectIntl
  intl: intlShape.isRequired,
};

const ActivityFeed = injectIntl(ActivityFeedComponent);

export default ActivityFeed;
